import { getAppContent, getUsers } from '@/lib/services/users';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@/utils/constants/QueryKey';
import { ContentType } from '@/constants/content.constants';
import { GetUsersArgs } from '@/types/User';

export const useViewUsers = (args?: GetUsersArgs) => {
  return useQuery({
    queryKey: [QueryKeys.GET_USERS, args],
    queryFn: () => getUsers(args),
  });
};

export const useGetAppContent = (type: ContentType) => {
  return useQuery({
    queryKey: [QueryKeys.GET_APP_CONTENT, type],
    queryFn: () => getAppContent(type),
  });
};
